import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: 'influencers',
  title: 'Influencers',
  endpoint: '/app/influencer',
}
